import { Component, AfterViewInit, OnDestroy, Renderer } from '@angular/core';
import { Router , NavigationStart, NavigationEnd, NavigationError} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import 'rxjs/add/operator/takeWhile';
import { AuthenticationService } from './services/authentication/authentication.service';
import { Message,SelectItem } from 'primeng/api';
import { Roles } from './guards/roles';
import { LoggingService } from './services/logging/logging.service';
import { UserService } from './services/user/user.service';
import { AppSideBarComponent } from './app.sidebar.component';
import { SendMessageModel } from './models/inModels/MessageModel';
import { BusinessService } from "./services/business/business-category.service";

enum MenuOrientation {
	STATIC,
	OVERLAY
}
declare var $: any;
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnDestroy {
	activeTabIndex = -1;
	sidebarActive = false;
	headerVisible = true;
	layoutMode: MenuOrientation = MenuOrientation.OVERLAY;
	topbarMenuActive: boolean;
	overlayMenuActive: boolean;
	staticMenuDesktopInactive: boolean;
	staticMenuMobileActive: boolean;
	rotateMenuButton: boolean;
	sidebarClick: boolean;
	topbarItemClick: boolean;
	menuButtonClick: boolean;
	activeTopbarItem: any;
	documentClickListener: Function;
	theme = 'green';
	alive: boolean;
	interval: number;
	private connection: any;
	private proxy: any;
	msgs: Message[] = [];
	threadId;
	openMessageDialog:boolean;

	constructor(
		public renderer: Renderer,
		public auth: AuthenticationService,
		private router: Router,
		private userService: UserService,
		private businesService: BusinessService) {
		this.alive = true;
		this.router.events.subscribe((event: any) => {
			if (event instanceof NavigationEnd) {
				//console.log(event);
				userService.logPageView(event.url);
			}
		});
		//this.startConnection();
	}

	startConnection(): void {
		this.connection = $.hubConnection(`${this.auth.apiUrl}`);
		this.proxy = this.connection.createHubProxy('ChatHub');
		console.log(this.connection);
		this.connection.qs = { "userId" : this.auth.getUser().userId };
		this.connection.start().done((data: any) => {
			console.log('Connected to Processing Hub');
			this.proxy.invoke('JoinThread', 1);
			this.proxy.invoke('PostMessage', 1, "TEST");
		}).catch((error: any) => {
			console.log('Hub error -> ' + error);
		});

		this.proxy.on('ReceiveMessage', Message => {
			console.log(Message);
		});
	}

	ngAfterViewInit() {
		this.documentClickListener = this.renderer.listenGlobal('body', 'click', (event) => {
			if (!this.topbarItemClick) {
				this.activeTopbarItem = null;
				this.topbarMenuActive = false;
			}

			if (!this.menuButtonClick && !this.sidebarClick && (this.overlay || !this.isDesktop())) {
				this.sidebarActive = false;
			}

			this.topbarItemClick = false;
			this.sidebarClick = false;
			this.menuButtonClick = false;
		});
	}

	showMessageDialog() {
		this.openMessageDialog = true;
	}

	onTabClick(event: Event, index: number) {
		
		if (this.activeTabIndex === index) {
			this.sidebarActive = !this.sidebarActive;
		} else {
			this.activeTabIndex = index;
			this.sidebarActive = true;
		}
		
		event.preventDefault();
	}

	closeSidebar(event: Event) {
		this.sidebarActive = false;
		event.preventDefault();
	}

	onSidebarClick(event: Event) {
		this.sidebarClick = true;
	}

	onTopbarMenuButtonClick(event: Event) {
		this.topbarItemClick = true;
		this.topbarMenuActive = !this.topbarMenuActive;

		event.preventDefault();
	}

	onMenuButtonClick(event: Event, index: number) {
		this.menuButtonClick = true;
		this.rotateMenuButton = !this.rotateMenuButton;
		this.topbarMenuActive = false;
		this.sidebarActive = !this.sidebarActive;

		if (this.layoutMode === MenuOrientation.OVERLAY) {
			this.overlayMenuActive = !this.overlayMenuActive;
		} else {
			if (this.isDesktop()) {
				this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
			} else {
				this.staticMenuMobileActive = !this.staticMenuMobileActive;
			}
		}

		if (this.activeTabIndex < 0) {
			this.activeTabIndex = 0;
		}
		event.preventDefault();
	}

	onTopbarItemClick(event: Event, item) {
		this.topbarItemClick = true;

		if (this.activeTopbarItem === item) {
			this.activeTopbarItem = null;
		} else {
			this.activeTopbarItem = item;
		}

		event.preventDefault();
	}

	onTopbarSearchItemClick(event: Event) {
		this.topbarItemClick = true;

		event.preventDefault();
	}

	get overlay(): boolean {
		return this.layoutMode === MenuOrientation.OVERLAY;
	}

	changeToStaticMenu() {
		this.layoutMode = MenuOrientation.STATIC;
	}

	changeToOverlayMenu() {
		this.layoutMode = MenuOrientation.OVERLAY;
	}

	isDesktop() {
		return window.innerWidth > 1024;
	}

	isMobile() {
		return window.innerWidth < 800;
	}

	ngOnDestroy() {
		if (this.documentClickListener) {
			this.documentClickListener();
		}

		this.alive = false;

		this.proxy.invoke('disconnect', this.auth.getUser().userId);
	}

	isAuthenticated() {
		return this.auth.isAuthenticated();
	}

	isAdmin() {
		const currentUser = this.auth.getUser();
		if (currentUser.userRole === Roles.Administrator) {
			return true;
		}
		return false;
	}


}





// WEBPACK FOOTER //
// ./src/app/app.component.ts